<template>
  <div id="events-list" class="pr-md-5">
    <CompactEventsList
      :events="filteredEvents"
      :nextEvent="getNextEvent"
      :maxEvents="0"
      :openEventDetailsOnClick="false"
      :showMoreEventsLink="false"
      :displayRegistrations="true"
      @onEventClick="openEventModal"
      ref="events-list"
    />
    <div class="text-center">
      <HMSpinner v-if="eventsLoading"></HMSpinner>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import * as EventUtils from '@/core/utils/events';
import EventStartStopModal from '@/web/views/admin/events/EventStartStopModal';
import { mapGetters } from 'vuex';
import HMSpinner from '@/web/components/common/HMSpinner';
import CompactEventsList from '@/web/components/events/CompactEventsList';

export default {
  name: 'EventsList',
  components: {
    HMSpinner,
    CompactEventsList,
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
    selectedDate: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      selectedEventType: 'event/selectedEventType',
      eventsLoading: 'event/eventsLoading',
    }),
    filteredEvents() {
      let events = this.events;
      if (this.selectedEventType) {
        events = events.filter(
          event => event.event_type === this.selectedEventType.code
        );
      }
      if (this.selectedDate) {
        return events.filter(event => {
          return (
            moment(event.event_start_datetime).get('month') ===
            this.selectedDate.get('month')
          );
        });
      }
      return [];
    },
    getNextEvent() {
      const nextEvents = this.filteredEvents.filter(event =>
        moment(event.event_start_datetime).isSameOrAfter(moment(), 'minute')
      );
      if (!nextEvents.length) return null;
      return nextEvents[0];
    },
  },
  methods: {
    eventType(event) {
      return this.$t(EventUtils.getEventTypeLabelKey(event.event_type));
    },
    shortDate(date, format) {
      return EventUtils.shortDate(date, format);
    },
    shortTime(datetime, format) {
      return EventUtils.shortTime(datetime, format);
    },
    openEventModal(event) {
      this.$store.dispatch('event/getEventDetails', event.id);
      this.$modal.show(EventStartStopModal);
    },
  },
  watch: {
    events: {
      handler(events) {
        if (events && events.length) {
          this.$nextTick(() => {
            const nextEvent = this.getNextEvent;
            if (nextEvent) {
              try {
                const eventElement = this.$refs['events-list'].$children.find(
                  child =>
                    child.$refs[
                      this.shortDate(nextEvent.event_start_datetime, 'MM-DD')
                    ]
                );
                if (eventElement) {
                  const yOffset = -30;
                  const y =
                    eventElement.$el.getBoundingClientRect().top +
                    window.pageYOffset +
                    yOffset;
                  window.scrollTo({ top: y, behavior: 'smooth' });
                }
              } catch (error) {
                // event not found
              }
            }
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.event-time {
  font-size: 13px;

  @include media-breakpoint-down(sm) {
    font-size: 10px;
  }
}

.pointer {
  cursor: pointer;
}

.cancelled-event {
  text-decoration: line-through;
  opacity: 0.7;
}
</style>
